<template>
  <div class="main-container">
    <div class="indigo background"></div>

    <v-container class="front">
      <v-layout wrap>
        <v-flex>
          <br />
          <v-img
            class="d-inline-block"
            height="50"
            width="200px"
            position="left"
            contain
            src="@/assets/logo.png"
          ></v-img>
          <div class="d-inline-block">
            <h3 class="white--text">{{ userData.orgName }}</h3>
            <p class="white--text">{{ userData.name }}</p>
          </div>
        </v-flex>
      </v-layout>

      <v-layout wrap mt-8>
        <v-tabs background-color="indigo" dark>
          <v-tab to="/client/home">Empleado</v-tab>
          <v-tab v-if="totalParticipants > 0" to="/client/monitoring"
            >Monitoreo</v-tab
          >
          <v-tab to="/client/help">Ayuda</v-tab>
          <v-tab v-if="totalParticipants > 0" to="/client/massive"
            >Captura masiva</v-tab
          >
          <v-spacer></v-spacer>
          <!-- <v-tab @click="getUserData">
            <v-icon>mdi-reload</v-icon>
          </v-tab> -->
          <v-tab @click="logOut">Salir</v-tab>
        </v-tabs>
      </v-layout>

      <v-layout wrap mt-8>
        <v-card
          class="white"
          width="100%"
          style="overflow-y: auto; overflow-x: hidden"
        >
          <router-view @updateTotal="updateTotalF"></router-view>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      totalParticipants: null,
      host: process.env.VUE_APP_HOST,
    };
  },
  computed: {
    ...mapState(["userData"]),
  },
  methods: {
    ...mapMutations(["setUser"]),

    logOut() {
      sessionStorage.removeItem("authorization");
      this.$router.push("/");
    },
    getLength() {
      let data = {
        idUser: sessionStorage.getItem("authorization"),
      };

      axios
        .post(this.host + "/participants/count.php", this.createFormData(data))
        .then((response) => {
          this.totalParticipants = response.data.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUserData() {
      let data = {
        idUser: sessionStorage.getItem("authorization"),
        query: "user",
      };

      axios
        .get(
          this.host +
            `/users/read.php?query=${data.query}&idUser=${data.idUser}`
        )
        .then((response) => {
          this.setUser(response.data.userData);
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateTotalF(val) {
      this.totalParticipants = val;
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    },
  },
  mounted() {
    this.setUser(JSON.parse(sessionStorage.getItem("user")));
    this.getLength();
    this.getUserData();
  },
};
</script>

<style scoped>
.background {
  height: 35vh;
  position: relative;
  z-index: 1;
}

.front {
  position: relative;
  top: -16rem;
  z-index: 10;
}
.main-container {
  height: 100vh;
}
</style>